import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link } from "react-router-dom";
import { pluck } from "underscore";
import ListSection from "../../components/ListSection";
import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Category";
import configuration from "../../config";
import { toast } from "react-toastify";

// List all categorys
function View({ location }) {
  const columns = [
    {
      title: "ID",
      field: "category_id",
      render: (rowData) => (
        <Link
          className="text-indigo-600 hover:text-indigo-900"
          to={`/Category/edit/${rowData.category_id}`}
        >
          {rowData.category_id}
        </Link>
      ),
    },
    { title: "Title", field: "title" },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "active"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.status}
        </span>
      ),
    },
  ];

  const btnGroups = [
    { id: 1, title: "Add New", type: "addNew", path: "/category/add" },
    { id: 2, title: "Make Active", type: "makeActive", path: "/category" },
    { id: 3, title: "Make Inactive", type: "makeInactive", path: "/category" },
    { id: 4, title: "Archive", type: "archive", path: "/category" },
    { id: 5, title: "Delete", type: "delete", path: "/category" },
  ];
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [ids, setIds] = useState([]);
  const [data, setData] = useState([  ]);

  useEffect(() => {
    if (location.state && location.state.is_added) {
      setShow(true);
      setTimeout(() => setShow(false), 3000);
    }
    getDatas();
  }, [location.state]);

  function getDatas() {
    configuration
      .getAPI({ url: "category/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          console.log("data.payload")
          console.log(data.payload)
          setData(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  function handleAction(type) {
    if (ids.length < 1) {
      return toast.error("Please select at least one record");
    } else if(type === 'delete'){
      setShowModal(true);
      return;
    }
    const sendData = {
      ids,
      type:
        type === "makeActive"
          ? "active"
          : type === "makeInactive"
          ? "inactive"
          : type,
    };
    console.log("sendData")
    console.log(sendData)
    configuration
      .postAPI({ url: "category/action", params: sendData })
      .then((data) => {
        if (data.status === 200) {
          getDatas();
          setIds([]);
          return toast.success(
            type === "delete"
              ? "Record deleted successfully"
              : "Record update successfully"
          );
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  function handleDelete() {
    const sendData={
      ids,
      type:'delete'
    }
    configuration.postAPI({url:'category/action', params:sendData}).then((data) => {
      if(data.status === 200){
        getDatas()
        setIds([]);
        setShowModal(false);
        return toast.success('Record deleted successfully')
      } else if (data.error) {
        return toast.error(data.error.message)
      } else {
        return toast.error('Something went wrong')
      }
    }).catch(error => {
      return toast.error(error.message)
    });
  }
  function handleCancel() {
    setShowModal(false);
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "category_id");
    setIds(idArr);
  };
  return (
    <>
      <Breadcrumb module={labels.category} />
      <Alert
        show={show}
        setShow={setShow}
        bgColorClass="green"
        caption="Success"
        message="Record added successfully"
      />
      <DeleteModel 
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <ListSection
        captionTitle="View Category"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
}

export default View;
